import { createFileRoute } from "@tanstack/react-router";
import Page from "@/pages/dashboard/calendar";

export const Route = createFileRoute("/dashboard/calendar")({
  component: Page,
});
